// Define Grid like the figma grid system
export const GridContainerColClasses = 'grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-12';
// Define Gap distences like figma
export const GridContainerGapClasses = 'sm:gap-8 gap-4';
// Define Item with full columns width
export const GridColFullWidth = 'lg:col-span-12 md:col-span-8 sm:col-span-6 col-span-4';
// Define Item with 10 columns starting from the second column
export const Grid10ColOfFullWidth = 'col-span-4 sm:col-span-6 md:col-span-8 lg:col-span-10 lg:col-start-2';
// Take up full width until large breakpoint then take up half width
export const GridColHalfWidthUntilLg = 'col-span-4 sm:col-span-6 md:col-span-8 lg:col-span-6';
// Define Screen Horizontal Padding
export const ScreenHorizontalPadding = 'px-4 sm:px-8 lg:px-0';

// Column
export const columnPadding = 'lg:px-[3rem] xl:px-[4.5rem] 2xl:px-[5rem]';
// Column + Gutter
export const columnGutterPadding = 'lg:px-[5rem] xl:px-[6.5rem] 2xl:px-[7rem]';
// 2 Column + Gutter
export const twoColumnsGutterPadding = 'lg:px-[8rem] xl:px-[11rem] 2xl:px-[12rem]';

export const gridREMLayout =
  'mx-auto box-content w-full lg:w-auto grid gap-4 sm:gap-8 ' +
  'grid-cols-4 sm:grid-cols-6 w-full md:grid-cols-8 ' +
  'lg:grid-cols-[repeat(12,3rem)] xl:grid-cols-[repeat(12,4.5rem)] 2xl:grid-cols-[repeat(12,5rem)]';

export const gridREMLayoutRows =
  'grid-rows-[repeat(auto-fill,minmax(16rem,32rem))] ' +
  'sm:grid-rows-[repeat(auto-fill,minmax(18rem,36rem))] ' +
  'md:grid-rows-[repeat(auto-fill,minmax(20rem,40rem))] ' +
  'lg:grid-rows-[repeat(auto-fill,minmax(24rem,48rem))]';
